module.exports = __webpack_public_path__ + "img/symbol_12_normal.ce06fa57.png";